import { safeSessionGet, safeSessionRemove, safeSessionSet } from './sessionStore'
import { newUuid } from './uuid'

/** Shared correlation id across landing_page_loaded / landing_page_frames_dwell /
 *  visit_options_preview_shown. Keyed by `pathname+search` so an SPA route
 *  change rotates the id; cleared on real pagehide (not bfcache). */

const KEY = 'pageViewId'
const PATH_KEY = 'pageViewIdPath'

function currentPath(): string {
    if (typeof location === 'undefined') return ''
    return `${location.pathname}${location.search}`
}

export function ensurePageViewId(): string {
    const path = currentPath()
    const storedPath = safeSessionGet(PATH_KEY)
    const stored = safeSessionGet(KEY)
    if (stored && storedPath === path) return stored
    const id = newUuid()
    safeSessionSet(KEY, id)
    safeSessionSet(PATH_KEY, path)
    return id
}

export function getPageViewId(): string | null {
    return safeSessionGet(KEY)
}

export function clearPageViewId(): void {
    safeSessionRemove(KEY)
    safeSessionRemove(PATH_KEY)
}
